
(function () {
  'use strict';

  /* @ngdoc object
   * @name vcdms.vcfile
   * @description
   *
   */
  angular
    .module('vcdms.vcfile', [
      'ui.router',
      'ui.grid',
      'ui.bootstrap',
      'ngTagsInput',
      'vcexam'
    ]);

  angular
    .module('vcdms.vcfile')
    .filter('trustUrl', ['$sce', function ($sce) {
      return function (recordingUrl) {
        return $sce.trustAsResourceUrl('/routes/files/filereader/' + recordingUrl);
      };
    }]);
}());
